import React, { useEffect, useState } from "react";
import get from "lodash/get";

import StoryCard6 from "../../molecules/story-card6";
import StoryCard7 from "../../molecules/story-card7";
import StoryCard5 from "../../molecules/story-card5";
import CollectionName from "../../molecules/collection-name";
import CollectionTitleHeader from "../../molecules/collection-title-header";

import { AdContainer } from "../../ads";
import { filterCollection, filterStory } from "../../helper/api";
import Separator from "../../atoms/separator";

import "./two-collection-ten-stories.m.css";

const TwoCollectionWithTenStroies = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const collections = filterCollection(collection);
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  if (!collections.length) {
    return null;
  }

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);
  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);

  const renderCollection1 = (collection) => {
    const stories = filterStory(collection);
    return (
      <div styleName="collection-wrapper1">
        <CollectionTitleHeader collection={collection} index={index} />
        <div>
          <div styleName="one-big">
            {stories?.splice(0, 1).map((item, index) => (
              <StoryCard5 story={item} headerType={12} key={index} bigCard={true} />
            ))}
          </div>
          <div styleName="four-story-wrapper">
            <div styleName="col col1">
              {stories?.splice(0, 2).map((item, index) => (
                <StoryCard6 story={item} headerType={2} key={index} />
              ))}
            </div>
            <div className="hide-mobile" styleName="vertical-rulers">
              <div></div>
              <div></div>
            </div>
            <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} />
            <div styleName="col col2">
              {stories?.splice(0, !isMobile ? 2 : 10).map((item, index) => (
                <React.Fragment key={index}>
                  <StoryCard6 story={item} headerType={2} key={index} />
                  {index === 3 ? <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} /> : null}
                  {index === 7 ? <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} /> : null}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <div className="hide-desktop">
          <Separator />
        </div>
      </div>
    );
  };

  const renderCollection2 = (collection) => {
    const stories = filterStory(collection);

    const storiesCount = desktopAdUnitId ? 3 : 5;

    return (
      <div styleName="collection-wrapper2">
        <CollectionName collection={collection} />
        <div>
          {stories?.splice(0, storiesCount).map((item, index) => (
            <div styleName="story-container" key={index}>
              <p styleName="story-count">{index + 1}</p>
              <StoryCard7 story={item} headerType={4} />
            </div>
          ))}
          {!isMobile && desktopAdUnitId ? (
            <div styleName="ad-wrapper">
              <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1680156228599-0" desktop={desktopAdUnitId} />
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <>
      <div styleName="wrapper">
        {renderCollection1(collections[0])}
        {renderCollection2(collections[1])}
      </div>
      <Separator />
    </>
  );
};

export default TwoCollectionWithTenStroies;
